"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _constants = require("@/config/constants");
var _vuex = require("vuex");
var _TableListClientsOrganization = _interopRequireDefault(require("./TableListClientsOrganization.vue"));
var _TableListAccessUser = _interopRequireDefault(require("./TableListAccessUser.vue"));
var _authGuard = require("@/auth/authGuard");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'UserDetail',
  bodyClass: 'user-detail-page',
  components: {
    TableListClientsOrganization: _TableListClientsOrganization.default,
    TableListBusinessUnit: _components.TableListBusinessUnit,
    TableListAccessUser: _TableListAccessUser.default
  },
  data: function data() {
    return {
      idUser: null,
      client: {},
      documents: [],
      listOrganizationPersons: [],
      listBusinessUnitPersons: [],
      listOfAccessUser: [],
      titleButtonShow: 'Exibir mais',
      listTypesUsers: _constants.LIST_TYPES_USERS
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['listAllClients'])), {}, {
    showDelete: function showDelete() {
      return (0, _authGuard.isUserAdmin)();
    },
    showMore: function showMore() {
      return (0, _authGuard.isUserAdmin)();
    }
  }),
  created: function created() {
    var id = this.$route.params.id;
    this.idUser = id;
    this.getDetails();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchUserDetail', 'fetchAllOrganizationPersons', 'fetchDocumentsClient', 'fetchAllBusinessUnitPersons', 'deleteOrganizationPersons', 'deleteBusinessUnitPersons', 'sendCredentialUser', 'fetchAllAccessUser'])), {}, {
    goBack: function goBack() {
      this.$router.back();
    },
    getDetails: function () {
      var _getDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$this$fetchUser, data, dataOP;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.idUser) {
                _context.n = 3;
                break;
              }
              _context.n = 1;
              return this.fetchUserDetail(this.idUser);
            case 1:
              _yield$this$fetchUser = _context.v;
              data = _yield$this$fetchUser.data;
              if (!data) {
                _context.n = 3;
                break;
              }
              this.client = _objectSpread(_objectSpread({}, data.person), {}, {
                role: data.role,
                user: data._id
              });
              _context.n = 2;
              return this.fetchAllOrganizationPersons(this.idUser);
            case 2:
              dataOP = _context.v;
              if (dataOP) {
                this.listOrganizationPersons = dataOP;
              }
              // get all users linked to BUs
              this.getBusinessUnitPersons();
              this.getListOfAccessUser();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getDetails() {
        return _getDetails.apply(this, arguments);
      }
      return getDetails;
    }(),
    getBusinessUnitPersons: function () {
      var _getBusinessUnitPersons = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.fetchAllBusinessUnitPersons(this.idUser);
            case 1:
              data = _context2.v;
              if (data) {
                this.listBusinessUnitPersons = data;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getBusinessUnitPersons() {
        return _getBusinessUnitPersons.apply(this, arguments);
      }
      return getBusinessUnitPersons;
    }(),
    showItens: function () {
      var _showItens = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.showMore = !this.showMore;
              if (this.showMore) {
                this.titleButtonShow = 'Exibir menos';
              } else {
                this.titleButtonShow = 'Exibir mais';
              }
              _context3.n = 1;
              return this.getListOfAccessUser();
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function showItens() {
        return _showItens.apply(this, arguments);
      }
      return showItens;
    }(),
    getListOfAccessUser: function () {
      var _getListOfAccessUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var limit, data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              limit = this.showMore ? 10 : 1;
              _context4.n = 1;
              return this.fetchAllAccessUser({
                idUser: this.client.user,
                params: {
                  limit: limit
                }
              });
            case 1:
              data = _context4.v;
              if (data) {
                this.listOfAccessUser = data.data.list;
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function getListOfAccessUser() {
        return _getListOfAccessUser.apply(this, arguments);
      }
      return getListOfAccessUser;
    }(),
    getDocuments: function () {
      var _getDocuments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.fetchDocumentsClient(this.idUser);
            case 1:
              data = _context5.v;
              if (data) {
                this.documents = data;
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function getDocuments() {
        return _getDocuments.apply(this, arguments);
      }
      return getDocuments;
    }(),
    openForm: function openForm() {
      this.$router.push("/users-form/".concat(this.idUser));
    },
    detailType: function detailType(item) {
      var detail = this.listTypesUsers.find(function (i) {
        return Number(i.id) === Number(item);
      });
      return detail ? detail.name : '--';
    },
    detailClient: function detailClient(item) {
      var detail = this.listAllClients.find(function (i) {
        return Number(i.OrganizationId) === Number(item);
      });
      return detail ? detail.Name : '--';
    },
    addNewOrganizationPerson: function addNewOrganizationPerson() {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalFormOrganizationPerson,
        hasModalCard: true,
        customClass: 'modal-form-new-organization-person-component',
        trapFocus: true,
        canCancel: ['escape', 'outside'],
        props: {
          idUser: this.idUser,
          action: this.getDetails
        }
      });
    },
    addNewBusinessUnitPerson: function addNewBusinessUnitPerson() {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalFormBusinessUnitPerson,
        hasModalCard: true,
        customClass: 'modal-form-new-organization-person-component',
        trapFocus: true,
        canCancel: ['escape', 'outside'],
        props: {
          idUser: this.idUser,
          action: this.getDetails
        }
      });
    },
    openModalSendMail: function openModalSendMail() {
      var _this = this;
      this.$buefy.dialog.prompt({
        message: 'Deseja enviar o e-mail com <b>Credencial de Acesso</b> para:',
        inputAttrs: {
          type: 'text',
          placeholder: 'Endereço de e-mail',
          value: this.client.email
        },
        confirmText: 'Enviar',
        cancelText: 'Cancelar',
        trapFocus: true,
        closeOnConfirm: false,
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(value, _ref) {
            var close, payload, data;
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.n) {
                case 0:
                  close = _ref.close;
                  payload = {
                    mail: value,
                    user: _this.client._id
                  };
                  close();
                  _context6.n = 1;
                  return _this.sendCredentialUser(payload);
                case 1:
                  data = _context6.v;
                  if (data) {
                    _this.$buefy.toast.open({
                      message: "E-mail enviado com sucesso!",
                      type: 'is-success'
                    });
                  }
                case 2:
                  return _context6.a(2);
              }
            }, _callee6);
          }));
          function onConfirm(_x, _x2) {
            return _onConfirm.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    },
    confirmDelete: function confirmDelete(item) {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalWarning,
        hasModalCard: true,
        trapFocus: true,
        props: {
          text: 'Deseja realmente exluir',
          action: this.deleteItem,
          name: item.name,
          idItem: item._id
        }
      });
    },
    confirmDeleteBusinessUnitPersons: function confirmDeleteBusinessUnitPersons(item) {
      var _item$businessUnitId;
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalWarning,
        hasModalCard: true,
        trapFocus: true,
        props: {
          text: 'Deseja realmente exluir',
          action: this.deleteItemBusinessUnitPersons,
          name: item === null || item === void 0 ? void 0 : (_item$businessUnitId = item.businessUnitId) === null || _item$businessUnitId === void 0 ? void 0 : _item$businessUnitId.name,
          idItem: item._id
        }
      });
    },
    deleteItem: function () {
      var _deleteItem = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(id) {
        var data;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return this.deleteOrganizationPersons(id);
            case 1:
              data = _context7.v;
              if (data) this.getDetails();
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function deleteItem(_x3) {
        return _deleteItem.apply(this, arguments);
      }
      return deleteItem;
    }(),
    deleteItemBusinessUnitPersons: function () {
      var _deleteItemBusinessUnitPersons = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(id) {
        var data;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return this.deleteBusinessUnitPersons(id);
            case 1:
              data = _context8.v;
              if (data) this.getBusinessUnitPersons();
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function deleteItemBusinessUnitPersons(_x4) {
        return _deleteItemBusinessUnitPersons.apply(this, arguments);
      }
      return deleteItemBusinessUnitPersons;
    }()
  })
};